import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';
import { Lti1p3Launch } from '@app/components/presentational/ClassRoom/Assignments/Lti1p3Launch/Lti1p3Launch';
import NavigationBackHeader from '@app/components/presentational/common/NavigationBackHeader/NavigationBackHeader';
import { getHomeViewRole } from '@app/selectors/home';
import { Box } from '@ublend-npm/aulaui-core';
import { NAVIGATION_SOURCE_UPCOMING_ASSIGNMENTS_VIEW_ALL_MODAL } from '@core/constants/analytics';
import useHomeUpcomingAssignments from './useHomeUpcomingAssignments';
import useOpenUpcomingAssignment from './useOpenUpcomingAssignment';
import UpcomingAssignmentsPage from './UpcomingAssignmentsPage';
import { getAssignmentTermLabel } from './getAssignmentTermLabel';

const UpcomingAssignmentsMobileScreen = () => {
  const dispatch = useDispatch();
  const viewRole = useSelector(getHomeViewRole);
  const classRooms = useSelector((state: any) => state.data?.classRooms || {});
  const { allItems, isLoading, isLoadingMore, hasMore, loadMore } =
    useHomeUpcomingAssignments({ viewRole });
  const { openAssignment, ltiLaunch, clearLtiLaunch, handleLtiLaunchError } =
    useOpenUpcomingAssignment();

  const handleOpenAssignment = useCallback(
    (assignment: Parameters<typeof openAssignment>[0], itemIndex: number) =>
      openAssignment(
        assignment,
        NAVIGATION_SOURCE_UPCOMING_ASSIGNMENTS_VIEW_ALL_MODAL,
        itemIndex
      ),
    [openAssignment]
  );

  const getTermLabel = useCallback(
    (spaceId: string) => getAssignmentTermLabel(classRooms[spaceId]),
    [classRooms]
  );

  const handleClose = useCallback(() => {
    dispatch(push({ pathname: '/home', state: { tracked: true } }));
  }, [dispatch]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          p: 2,
          pt: 1,
          gap: 1,
          flexDirection: 'column',
        }}
      >
        <NavigationBackHeader onClick={handleClose} />
        <UpcomingAssignmentsPage
          onClose={handleClose}
          assignments={allItems}
          viewRole={viewRole}
          isLoading={isLoading}
          getTermLabel={getTermLabel}
          onOpenAssignment={handleOpenAssignment}
          hasMore={hasMore}
          isLoadingMore={isLoadingMore}
          onLoadMore={loadMore}
        />
      </Box>

      {ltiLaunch && (
        <Lti1p3Launch
          providerId={ltiLaunch.providerId}
          resourceLinkId={ltiLaunch.resourceLinkId}
          resourceLinkTitle={ltiLaunch.title}
          assignmentId={ltiLaunch.assignmentId}
          onSuccessLaunch={clearLtiLaunch}
          onErrorLaunch={handleLtiLaunchError}
        />
      )}
    </>
  );
};

export default UpcomingAssignmentsMobileScreen;
